<template>
  <div class="app-container">
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" @click="handleAdd">添加分组</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="分组" width="150" align="center" prop="name" />
      <el-table-column label="标签" align="center" prop="size" />
      <el-table-column label="操作" min-width="130" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleSee(scope.row)">添加标签</el-button>
          <el-button type="text" @click="handleEdit(scope.row)">删除分组</el-button>
          <el-button type="text" @click="handleDelete(scope.row)">编辑分组</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
    <!-- <AddTags ref="addTagsDialog" @success="getList"></AddTags> -->
  </div>
</template>

<script>
import { queryBusinessByTargetId } from "@/api/crm/business";
import { amountFormat } from "@/utils/index";
// import AddTags from "./components/addTagsDialog";

export default {
  name: "BusinessList",
  props: {
    customerId: {},
    contactId: {},
    height: {
      type: String,
      default() {
        return "250";
      }
    }
  },
  data() {
    return {
      total: 1,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      dataList: [
        {
          name: "一体化设备",
          size: "20M",
          folder: "产品册",
          desc: "说明文字",
          updateTime: "2021.03.01 12:12:12"
        }
      ],
      amountFormat
    };
  },
  created() {
    if (this.customerId || this.contactId) {
      this.queryList();
    }
  },
  components: {
    // AddTags
  },
  watch: {
    customerId(val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = [];
      }
    },
    contactId(val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = [];
      }
    }
  },
  methods: {
    handleAdd() {
      this.$refs.addTagsDialog.open();
    },
    getList() {},
    queryList() {
      this.loading = true;
      queryBusinessByTargetId({
        customerId: this.customerId,
        contactId: this.contactId
      })
        .then(response => {
          this.dataList = response.data || [];
          this.$emit("after-query", this.dataList);
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    /** 详细按钮操作 */
    toDetail(row) {
      this.$router.push("/crm/business/detail/" + row.id);
    }
  }
};
</script>
